import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Placeholder, Card, CardBody, CardHeader, Row, Col } from "react-bootstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import ControlledTextField from "../../../components/ControlledTextField";
import { useSelector } from "react-redux";
import { useLazyGetCartsForRestaurantByRestaurantIdQuery } from "../../../redux/services/restaurantServices";
import {
    useUpdateRestaurantCommissionMutation,
    useLazyGetCommissionsForRestaurantQuery,
} from "../../../redux/services/CommissionService";
import { toast } from "react-toastify";
import "./index.css";
import { CartList } from "../../CartController/CartList";
import { useMenuItems } from "../../Products/MenuItem/ItemTable/AllItems";
import { useFetchCustomMenus } from "../../Products/CustomizedMenu/CustomizeMenuTable/index";
import { useFetchSetMenus } from "../../Products/SetMenu/MenuTable";
import CartCommissionForm from "../../../forms/CartCommissionForm";
import ButtonComponent from "../../../components/ButtonComponent";
import SavingButton from "../../../components/SavingMessageComponent";

export interface CommissionData {
    restaurantId: string;
    restaurantCommission: string;
    cartId: string;
    cartCommission: number;
    products: any;
    productName: string;
    productCommission: number;
    cartName: any;
    product: any;
    merchantId: string;
    commission: number;
    isAvailable: boolean;
    isClickSave: boolean;
}

export interface Products {
    menuItemId: string;
    commission: number;
    displayName: string;
    imageUrl: string;
}

export interface CartData {
    cartName: any;
    cartId: string;
    commission: number;
    imageUrl?: string;
    status?: string;
    products: Products[];
    isNewCreatedCart: boolean;
}

export interface Commissions {
    systemDefaultCommission: any;
    restaurantCommission: any;
    restaurantCartCommission: CartData[];
}

const Commission: React.FC = () => {
    const selectedRestaurantId = useSelector(
        (state: any) => state.restaurant.selectedRestaurantDetails.id
    );

    const [cartsList, setCartsList] = useState<CartList[]>([]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [productsItemsList, setProductsItemsList] = useState<Products[]>([]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [commissionDataList, setCommissionDataList] = useState<Products[]>([]);

    const [isAddNewCart, setIsAddNewCart] = useState<boolean>(false);
    const [isErrorRestaurantCommission, setIsErrorRestaurantCommission] = useState<boolean>(false);

    const [commissionCartList, setCommissionCartList] = useState<CartData[]>([]);
    const [commissions, setCommissions] = useState<Commissions>();
    const [isSaving, setIsSaving] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isClickSave, setIsClickSave] = useState(false);

    const [newCartCommissionProduct, setNewCartCommissionProduct] = useState<Products[]>([]);

    // const [errorType, setErrorType] = useState<"systemDefault" | "cartCommission" | "unknown" | "">();

    // const { data: commissionData, isLoading: isCommissionLoading } =
    //     useGetCommissionsForRestaurantQuery(selectedRestaurantId);

    const [triggerCommissionData, { data: commissionData, isLoading: isCommissionLoading }] = useLazyGetCommissionsForRestaurantQuery();

    const [triggerAllCartsForRestaurant, { data: cartsForRestaurant }] =
        useLazyGetCartsForRestaurantByRestaurantIdQuery();

    // const [deleteCartCommission] = useDeleteCartCommissionMutation();

    const { items, restaurantId } = useMenuItems();

    const { setMenus } = useFetchSetMenus(restaurantId);

    const { customMenus } = useFetchCustomMenus(restaurantId);

    const productsData = [...items, ...setMenus, ...customMenus];



    const [updateCommission] =
        useUpdateRestaurantCommissionMutation();

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
    } = useForm<CommissionData>({
        defaultValues: {
            restaurantId: "",
            restaurantCommission: "",
            cartId: "",
            cartCommission: 0,
            products: "",
            productName: "",
            productCommission: 0,
            cartName: "",
            product: "",
        },
    });

    const restaurantCommissionWatcher = watch("restaurantCommission");

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        let cartList = [];

        if (
            commissionData &&
            commissionData.restaurantCommissionList &&
            commissionData.restaurantCommissionList.restaurantCartCommission &&
            cartsForRestaurant
        ) {
            const commissionCartList =
                commissionData.restaurantCommissionList.restaurantCartCommission;
            const newMergedList = commissionCartList
                .map((commissionCart: any) => {
                    const foundCart = cartsForRestaurant.find(
                        (cart: any) => cart.id === commissionCart.cartId
                    );
                    const comProductList = Object.entries(
                        commissionCart.products ?? {}
                    ).map(([menuItemId, productObj]: [string, any]) => {
                        const findProduct = productsData.filter(
                            (product: any) => menuItemId === product?.id
                        );
                        return {
                            menuItemId,
                            commission: productObj.commission ?? 0,
                            displayName: productObj.displayName ?? "",
                            imageUrl: findProduct[0]?.imageUrl[0] ?? "",
                        };
                    });

                    if (!foundCart) return null;

                    return {
                        cartId: foundCart.id,
                        cartName: foundCart.displayName,
                        imageUrl: foundCart.imageUrl,
                        status: foundCart.status,
                        commission: commissionCart.commission ?? 0,
                        products: comProductList ?? {},
                        isNewCreatedCart: false,
                    };
                })
                .filter(Boolean);
            cartList = newMergedList;
        }

        const obj: Commissions = {
            systemDefaultCommission:
                commissionData?.restaurantCommissionList?.systemDefaultCommission,
            restaurantCommission:
                commissionData?.restaurantCommissionList?.restaurantCommission
                    .commission,
            restaurantCartCommission: cartList,
        };
        setCommissions(obj);

        setValue(
            "restaurantCommission",
            commissionData?.restaurantCommissionList?.restaurantCommission.commission
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [commissionData, cartsForRestaurant]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (cartsForRestaurant) {
            const commissionCartIds =
                commissionData?.restaurantCommissionList?.restaurantCartCommission?.map(
                    (item: any) => item.cartId
                );

            const filteredCartList = cartsForRestaurant?.filter(
                (cart: any) => !commissionCartIds?.includes(cart?.id)
            );
            setCartsList(filteredCartList);

            const updatedCartData = commissionCartList.map((cart) => {
                const matchingCart = cartsForRestaurant.find(
                    (c: CartList) => c.id === cart.cartId
                );
                if (matchingCart) {
                    return { ...cart, cartName: matchingCart.displayName };
                }
                return cart;
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
            setCommissionCartList(updatedCartData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartsForRestaurant, selectedRestaurantId, commissionData]);

    useEffect(() => {
        if (selectedRestaurantId) {
            triggerAllCartsForRestaurant(selectedRestaurantId);
        }
    }, [selectedRestaurantId, triggerAllCartsForRestaurant]);

    useEffect(() => {
        if (selectedRestaurantId) {
            triggerCommissionData(selectedRestaurantId);
        }
    }, [selectedRestaurantId, triggerCommissionData]);

    useEffect(() => {
        if (selectedRestaurantId) {
            setCommissionDataList(
                commissionData?.restaurantCommissionList?.restaurantCartCommission
            );
        }
    }, [selectedRestaurantId, commissionData]);

    useEffect(() => {
        if (commissions) {
            const filter = commissions?.restaurantCartCommission?.filter(
                (cart: any) => cart.isNewCreatedCart
            );

            if (filter) {
                setNewCartCommissionProduct(filter[0]?.products);
            }
        }
    }, [commissions]);


    const handleAddNewSection = () => {
        setIsAddNewCart(true);
    };

    const saveCommission = async (obj: any) => {
        setIsClickSave(true);
        setIsSaving(true);
        try {
            await updateCommission(obj).unwrap();
            toast.success("Commission data saved successfully!");
            setIsAddNewCart(false);
            setIsClickSave(false);
            setIsSaving(false);
            setValue("cartName", "");
            //setValue("cartCommission-new", 0);
            setValue("productName", "");
            setValue("productCommission", 0);
            setValue("product", []);
            //setSelectedProduct(null);
            triggerCommissionData(selectedRestaurantId);
        } catch (error) {
            console.error(error);
            toast.error("Somthing went Wrong ...");
            setIsClickSave(false);
            setIsSaving(false);
        }
    };


    const handleSaveRestaurantCommission = () => {
        setIsSaving(true);

        const systemDefaultCommission = commissionData?.restaurantCommissionList?.systemDefaultCommission;

        if (restaurantCommissionWatcher && restaurantCommissionWatcher > systemDefaultCommission &&
            (restaurantCommissionWatcher !== null ||
                restaurantCommissionWatcher !== undefined)) {
            setIsErrorRestaurantCommission(false);
            const obj = {
                restaurantId: selectedRestaurantId,
                restaurantCommission: parseInt(restaurantCommissionWatcher ?? "0", 10),
            };

            saveCommission(obj);
        } else {
            setIsErrorRestaurantCommission(true);
            setIsSaving(false);
        }
    };

    const onSubmit = () => {
    };

    return (
        <div>
            <BreadCrumbs hasSubMenus={true} />

            {/* {isCommissionLoading && (
                <div className="loading-overlay">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )} */}

            <Form onSubmit={handleSubmit((data, index) => onSubmit())}>
                {/*resturant commission card*/}
                <Card>
                    <CardBody className="py-3">

                        {commissions?.systemDefaultCommission && (
                            <><span className="text-warning"><strong
                                className="pb-2">System Default Commission {commissions?.systemDefaultCommission}%</strong></span><br /></>
                        )}

                        <div className="d-flex justify-content-between align-items-end">
                            <div>
                                <div className="w-100 pb-2">
                                    <ControlledTextField
                                        inputName={"restaurantCommission"}
                                        placeholder={"Enter Commission"}
                                        label={"Restaurant Commission"}
                                        hasSideLabel={true}
                                        sideLabel={"%"}
                                        rules={{
                                            required: false,
                                            pattern: /^[0-9]*$/,
                                        }}
                                        errors={errors}
                                        control={control}
                                    />
                                </div>
                                {isErrorRestaurantCommission && (
                                    <span className="text-danger my-3">Restaurant commission should be higher than the defaultcommission</span>)}
                            </div>

                            <div>
                                {isSaving ? (<SavingButton isSaving={true} />
                                ) : (<ButtonComponent
                                    titel={"Save"}
                                    onClick={handleSaveRestaurantCommission}
                                    isDisabled={false}
                                />)}
                                {/* <ButtonComponent
                                    titel="Save"
                                    onClick={handleSaveRestaurantCommission}
                                /> */}
                            </div>
                        </div>
                    </CardBody>
                </Card>

                {/*cart commission card*/}
                <Card>
                    <CardHeader>
                        <strong>Available Cart Commissions</strong>
                    </CardHeader>
                </Card>

                {/*Add new commission cart button*/}
                <Card className="d-flex card-commission justify-content-center align-items-center">
                    <CardBody className="card-commission-body text-center">
                        <button
                            disabled={isAddNewCart}
                            onClick={handleAddNewSection}
                            className="add-section-button"
                        >
                            + Add New Cart
                        </button>
                    </CardBody>
                </Card>

                {isCommissionLoading ? (
                    <>
                        <Row className="g-2">
                            {[...Array(4)].map((_, rowIndex) => (
                                <Row key={rowIndex} className="g-3">
                                    {[...Array(2)].map((_, colIndex) => (
                                        <Col key={colIndex} md={6}>
                                            <Card>
                                                <Card.Body
                                                    style={{ width: "250px", height: "100px" }}
                                                    className="d-flex flex-column justify-content-center"
                                                >
                                                    <Placeholder as={Card.Title} animation="wave">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                    <Placeholder as={Card.Text} animation="wave">
                                                        <Placeholder xs={8} />
                                                        <Placeholder xs={4} />
                                                    </Placeholder>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            ))}
                        </Row>
                    </>
                ) : (<Row>
                    <Col lg={12}>
                        {isAddNewCart && (
                            <CartCommissionForm
                                errors={errors}
                                control={control}
                                watch={watch}
                                cartsList={cartsList}
                                productsItemsList={productsItemsList}
                                onSubmit={onSubmit}
                                productsData={productsData}
                                cartCommission={null}
                                index={null}
                                isNewCart={true}
                                setCommissions={setCommissions}
                                commissions={commissions}
                                setValue={setValue}
                                selectedRestaurantId={selectedRestaurantId}
                                restaurantCommissionWatcher={restaurantCommissionWatcher || ""}
                                saveCommission={saveCommission}
                                // deleteCart={deleteCart}
                                setIsClickSave={setIsClickSave}
                                setIsAddNewCart={setIsAddNewCart}
                                newCartCommissionProduct={newCartCommissionProduct}
                                systemDefaultCommission={commissions?.systemDefaultCommission}
                                setIsErrorRestaurantCommission={setIsErrorRestaurantCommission}
                            />
                        )}
                    </Col>
                    {commissions &&
                        commissions.restaurantCartCommission.length > 0 &&
                        commissions.restaurantCartCommission.map(
                            (cartCommission, index) => (
                                <>
                                    {!cartCommission?.isNewCreatedCart && (<Col key={index} lg={6}>
                                        <CartCommissionForm
                                            errors={errors}
                                            control={control}
                                            watch={watch}
                                            cartsList={cartsList}
                                            productsItemsList={productsItemsList}
                                            onSubmit={onSubmit}
                                            productsData={productsData}
                                            cartCommission={cartCommission}
                                            index={index}
                                            isNewCart={false}
                                            setCommissions={setCommissions}
                                            commissions={commissions}
                                            setValue={setValue}
                                            selectedRestaurantId={selectedRestaurantId}
                                            restaurantCommissionWatcher={restaurantCommissionWatcher || ""}
                                            saveCommission={saveCommission}
                                            // deleteCart={deleteCart}
                                            systemDefaultCommission={commissions?.systemDefaultCommission}
                                            setIsClickSave={setIsClickSave}
                                            setIsAddNewCart={setIsAddNewCart}
                                            setIsErrorRestaurantCommission={setIsErrorRestaurantCommission}
                                            commissionData={commissionData}
                                        />
                                    </Col>)}
                                </>
                            )
                        )}



                </Row>)}
                {/* <Row>
                    {commissions &&
                        commissions.restaurantCartCommission.length > 0 &&
                        commissions.restaurantCartCommission.map(
                            (cartCommission, index) => (
                                <>
                                    {!cartCommission?.isNewCreatedCart && (<Col key={index} lg={6}>
                                        <CartCommissionForm
                                            errors={errors}
                                            control={control}
                                            watch={watch}
                                            cartsList={cartsList}
                                            productsItemsList={productsItemsList}
                                            onSubmit={onSubmit}
                                            productsData={productsData}
                                            cartCommission={cartCommission}
                                            index={index}
                                            isNewCart={false}
                                            setCommissions={setCommissions}
                                            commissions={commissions}
                                            setValue={setValue}
                                            selectedRestaurantId={selectedRestaurantId}
                                            restaurantCommissionWatcher={restaurantCommissionWatcher || ""}
                                            saveCommission={saveCommission}
                                            // deleteCart={deleteCart}
                                            systemDefaultCommission={commissions?.systemDefaultCommission}
                                            setIsClickSave={setIsClickSave}
                                            setIsAddNewCart={setIsAddNewCart}
                                            setIsErrorRestaurantCommission={setIsErrorRestaurantCommission}
                                            commissionData={commissionData}
                                        />
                                    </Col>)}
                                </>
                            )
                        )}
                    Add new commission cart

                    <Col lg={6}>
                        {isAddNewCart && (
                            <CartCommissionForm
                                errors={errors}
                                control={control}
                                watch={watch}
                                cartsList={cartsList}
                                productsItemsList={productsItemsList}
                                onSubmit={onSubmit}
                                productsData={productsData}
                                cartCommission={null}
                                index={null}
                                isNewCart={true}
                                setCommissions={setCommissions}
                                commissions={commissions}
                                setValue={setValue}
                                selectedRestaurantId={selectedRestaurantId}
                                restaurantCommissionWatcher={restaurantCommissionWatcher || ""}
                                saveCommission={saveCommission}
                                // deleteCart={deleteCart}
                                setIsClickSave={setIsClickSave}
                                setIsAddNewCart={setIsAddNewCart}
                                newCartCommissionProduct={newCartCommissionProduct}
                                systemDefaultCommission={commissions?.systemDefaultCommission}
                                setIsErrorRestaurantCommission={setIsErrorRestaurantCommission}
                            />
                        )}
                    </Col>
                </Row> */}
            </Form>
        </div >
    );
};

export default Commission;
// test